// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3a7YN","Div":"CustomFadeBox_Div__VZroT","LargeDiv":"CustomFadeBox_LargeDiv__qDA8G"};